module.exports = __webpack_public_path__ + "static/media/yellowCircleNobg.a73f4b2a.svg";